<template>
    <header class="container-fluid">
        <div class="row redBar">
            <div class="col-md-7 offset-1 my-auto">
                <div>PLATEFORME DE RECOUVREMENT DES COMMISSAIRES DE JUSTICE</div>
            </div>
            <div class='col-md-4 centered socials'>
              <a rel='noreferrer noopener' :href='user_manual_link'  target='_blank'><span
                class='icon-book'></span> MANUEL D'UTILISATION</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-7 offset-1 my-auto">
                <a href='https://www.credicys.fr'><img src='../../assets/header-logo-credicys.png' alt='Credicys'/></a>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'header-bar',
      data: function () {
        return {
          user_manual_link: 'src/public/doc/Credicys - documentation utilisateur non connecte.pdf?' + Date.now(),
         }
      }
    }
</script>

<style lang='scss' scoped>
    .redBar {
        font-size: 0.75em;
        padding: 12px;
        background-color: #d0053c;
    }

    header {
        background-color: #f7f7f7;
        color: white;
    }

    img {
        padding: 1em 0 0 1em;
    }

    .socials {
        font-size: 15px;
        a {
            padding: 0 1em 0 1em;
            border: none;
            &:hover {
                text-decoration: none;
            }
        }
    }

    a {
        color: white;
        &:visited {
            line-height: inherit;
        }

        &:visited, &:focus {
            text-decoration: none;
            outline: 0;
        }

        &:hover {
            text-decoration: underline;
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderBar.vue